import axios from "axios"

import { backendURL } from "../config"

export const sendUserLocationInfo = async (userInfoObject) => {
    await axios.post(`${backendURL}/user-location`, userInfoObject)
}
